import script from "./manage-users.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-users.vue?vue&type=script&setup=true&lang=js"

import "./manage-users.vue?vue&type=style&index=0&id=38d70be4&lang=scss"

const __exports__ = script;

export default __exports__